<script>
import baseInput from './baseInput'
export default {


    mixins: [ baseInput ],

    name: 'text-editor',

    props: {
        customToolbar: Array,
    },

}
</script>

<template lang="html">
    <vue-editor :editorToolbar="customToolbar" class="text-editor" v-model="internalValue"></vue-editor>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/textEditor.vue